import { chakra } from '@stockx/ui';

export const AboutNavItemWrapper = chakra('li', {
  baseStyle: {
    ' .about-dropdown': {
      visibility: 'hidden',
    },

    _hover: {
      ' .about-dropdown': {
        visibility: 'visible',
      },
    },
  },
});
